import { Routes } from '@angular/router';
import { AdminComponent, ForgotPasswordComponent, LoginComponent, LogoutComponent, RegisterComponent, SsoComponent, ProfileComponent, EmployeeComponent } from 'wire-frame';
import { PrescriptionsComponent } from './component/admin/prescriptions/prescriptions.component';
import { MedicineComponent } from './component/admin/medicine/medicine.component';
import { PatientRegistrationComponent } from './component/admin/patient-registration/patient-registration.component';
import { PreConsultationComponent } from './component/admin/pre-consultation/pre-consultation.component';
import { PurchaseOrderComponent } from './component/admin/purchaseorder/purchaseorder.component';
import { SupplierComponent } from './component/admin/supplier/supplier.component';
import { AdminInventoryComponent } from './component/admin/admin-inventory/admin-inventory.component';
import { AppointmentComponent } from './component/admin/appointment/appointment.component';
import { AppointmentListComponent } from './component/admin/appointment-list/appointment-list.component';
import { AppointmentKanbanComponent } from './component/admin/appointment-kanban/appointment-kanban.component';
import { CalendarComponent } from './component/admin/calendar/calendar.component';
import { ClinicSupplyComponent } from './component/admin/clinicsupply/clinicsupply.component';
import { PharmacyComponent } from './component/admin/pharmacy/pharmacy.component';
import { authGuard } from './auth.guard';
import { DashboardComponent } from './component/admin/dashboard/dashboard.component';
import { CertificatesComponent } from './component/admin/certificates/certificates.component';
import { MedicineFinderComponent } from './component/admin/medicine-finder/medicine-finder.component';
import { RepertoryComponent } from './component/admin/repertory/repertory.component';
import { AnalyticsCollectionsComponent } from './component/admin/analytics-collections/analytics-collections.component';
import { ReceptionDuesComponent } from './component/admin/reception-dues/reception-dues.component';
import { BillsComponent } from './component/admin/bills/bills.component';
import { CustomerPatientRegistrationComponent } from './component/public/customer-patient-registration/customer-patient-registration.component';

export const routes: Routes = [
  {
    path: 'register',
    component: CustomerPatientRegistrationComponent,
    title: 'Patient Registration',
  },
  {
    path: 'sso',
    component: SsoComponent,
    children: [
      { path: 'admlogin', component: LoginComponent, title: 'Login' },
      // {
      //   path: 'agentlogin',
      //   component: AgentLoginComponent,
      //   title: 'Agent Login',
      // },
      // {
      //   path: 'customerlogin',
      //   component: CustomerLoginComponent,
      //   title: 'Customer Login',
      // },
      // {
      //   path: 'admregister',
      //   component: RegisterComponent,
      //   title: 'Register User',
      // },
      // {
      //   path: 'applied-passport',
      //   component: AppliedPassportComponent,
      //   title: 'Applied Passport',
      // },

      // {
      //   path: 'customer-register',
      //   component: CustomerRegisterComponent,
      //   title: 'Customer Register',
      // },
      // {
      //   path: 'agent-register',
      //   component: AgentRegisterComponent,
      //   title: 'Agent Register',
      // },
      {
        path: 'register',
        component: RegisterComponent,
        title: 'Register User',
      },
      {
        path: 'admforgotpassword',
        component: ForgotPasswordComponent,
        title: 'Forgot Password',
      },
      { path: 'admlogout', component: LogoutComponent },
      { path: '', redirectTo: '/sso/admlogin', pathMatch: 'full' },
    ],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivateChild: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, title: 'Dashboard' },
      { path: 'profile', component: ProfileComponent, title: 'Profiles' },
      { path: 'employee', component: EmployeeComponent, title: 'Profiles' },
      {
        path: 'prescriptions',
        component: PrescriptionsComponent,
        title: 'Prescriptions',
      },
      {
        path: 'medicine',
        component: MedicineComponent,
        title: 'medicine',
      },
      {
        path: 'patient-registration',
        component: PatientRegistrationComponent,
        title: 'Patient Registration',
      },
      {
        path: 'pre-consultation',
        component: PreConsultationComponent,
        title: 'Pre Consultation',
      },
      {
        path: 'purchaseorder',
        component: PurchaseOrderComponent,
        title: 'Purchase Order',
      },
      {
        path: 'supplier',
        component: SupplierComponent,
        title: 'Supplier',
      },
      {
        path: 'admin-inventory',
        component: AdminInventoryComponent,
        title: 'Admin Inventory',
      },
      {
        path: 'appointment',
        component: AppointmentComponent,
        title: 'Appointment',
      },
      {
        path: 'appointment-list',
        component: AppointmentListComponent,
        title: 'Appointment List',
      },
      {
        path: 'appointment-kanban',
        component: AppointmentKanbanComponent,
        title: 'Appointment Kanban',
      },
      {
        path: 'calendar',
        component: CalendarComponent,
        title: 'Calendar',
      },
      {
        path: 'clinicsupply',
        component: ClinicSupplyComponent,
        title: 'Clinic Supply'
      },
      {
        path: 'pharmacy',
        component: PharmacyComponent,
        title: 'Pharmacy'
      },
      {
        path: 'certificates',
        component: CertificatesComponent,
        title: 'Certificates'
      },
      {
        path: 'medicine-finder',
        component: MedicineFinderComponent,
        title: 'Medicine Finder'
      },
      {
        path: 'repertory',
        component: RepertoryComponent,
        title: 'Repertory'
      },
      {
        path: 'analytics-collections',
        component: AnalyticsCollectionsComponent,
        title: 'Analytics Collections'
      },
      {
        path: 'reception-dues',
        component: ReceptionDuesComponent,
        title: 'Reception Dues'
      },
      {
        path: 'bills',
        component: BillsComponent,
        title: 'Bills'
      },
      { path: '', redirectTo: '/admin/dashboard', pathMatch: 'full' },
    ],
  },
  { path: '', redirectTo: '/sso/admlogin', pathMatch: 'full' },
  // { path: '**', component: PageNotFoundComponent, pathMatch: 'full'}
];
// AIzaSyDRT3XwByQN5jwYGz2U-OmwQgNyvxDGLWU
